import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { upscmainsmock } from "../../components/Service/upscmainsmocktest";
import { useState } from "react";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {


    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
    const [valuephno, setvaluephno] = useState(undefined);
    //const [captchaerror, setcaptchaerror] = useState(undefined);
    const [selectedRadio, setSelectedRadio] = useState();
    function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
      
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }
      
        return jsonObject;
      }
    const HandleChangeValue = (e) => {
        setSelectedRadio(e.target.value);
        if (e.target.value == 'No'){
          
            document.getElementById("programme").value = ''
        }
    };

    function onChange(value) {
        if (value == null) {
            setverified(false);
        }
        else {
            setverified(true);
        }
    }

    async function handleOnSubmit(e) {
        e.preventDefault();
       
            const formData = {};
            formData['formType'] = "SIAUPSCMainsTestCenter";
            formData['title'] = "SIA UPSC Mains Test Center";
            //formData['branch'] = props.branchname;
            Array.from(e.currentTarget.elements).forEach(field => {
                if (!field.name) return;
                if (field.type === "radio") {
                    if (field.checked) {
                        formData[field.name] = field.value;
                    }
                } else {
                    formData[field.name] = field.value;
                }
            });
           // formData['countryCode'] = "+91";
            formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
            formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
            
           const transform={fields:{...formData}};
           console.log(transform);
            setIsLoading(true);
            upscmainsmock(transform)
                .then(response => {
                   
                    setModalOtp(true);
                    setmodalOtpstatus(response.message);
                    //window.grecaptcha.reset(setverified);
                    //setverified(false);
                    setvaluephno(undefined);
                    document.getElementById("SIAUPSCMainsTestCenter").reset();
                    setIsLoading(false);
                })
                .catch(error => {
                    setModalOtp(true);
                    setmodalOtpstatus("failure");
                    setmodalOtpExceptionMessage(error.message.split("Error: ")[1]);
                   // window.grecaptcha.reset(setverified);
                    //setverified(false);
                    setIsLoading(false);
                })

      
        
    }
    return (
        <>

            {isLoading &&
                <div class="APIPreLoader" id="APIPreLoader">
                    <div class="loader">Loading...</div>
                </div>
            }
            <Otpverification show={modalOtp} title={modalOtpstatus}  frompage="SIAUPSCMainsTestCenter" onHide={() => setModalOtp(false)} />
            <div className="container-fluid pt-3">
                <div className="row mx-auto pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
                    <div className="col">

                    <div className="container pt-4">

                        <div className="row">

                            <div className="col-12 mx-auto">
                                <h2 className={`${styles.contactheader}`}>Select Centers Registration &nbsp;&nbsp;&nbsp;<span className={`${styles.acheiverrank2} mb-0`} style={{color: '#DB1B0D'}}></span></h2>
                                <form onSubmit={handleOnSubmit} id="SIAUPSCMainsTestCenter" autoComplete="off">

                                    <div className="row pt-4">

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="text" className={`${styles.mainsmock} form-control`} placeholder="Name" autoComplete="off" name="name" minLength="1" required />
                                            </div>
                                        </div>

                                        

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="email" className={`${styles.mainsmock} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                                            </div>
                                        </div>
                                        

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="tel" className={`${styles.mainsmock} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                                            </div>
                                        </div>

                                       

                                        <div className="col-12 col-xl-3 col-lg-6 ">
                                        <div className="mb-4">
                                        <select className={`${styles.acheiverrank} form-select form-control`} name="centers" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Select Centers</option>
                                            <option value="Chennai">Chennai</option>
                                            <option value="Delhi">Delhi</option>
                                            <option value="Bengaluru">Bengaluru</option>
                                            <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                                            <option value="Hyderabad">Hyderabad</option>
                                            <option value="Online">Online</option>
                                         </select>
                                        </div>
                                        </div>

                                   
                                        <div className="col-12 col-xl-6 pt-2">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="yes" name="notification" id={styles.invalidCheck2} />
                                            <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                                                I would like to receive updates from Shankar IAS Academy
                                            </label>
                                        </div>


                                        <div className="d-flex flex-wrap mb-3">
                                           {/* <div className="me-3 mt-2">
                                                <ReCAPTCHA className={`${styles.captcha}`}
                                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                                    onChange={onChange}

                                                />
                                                <div className="">
                                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                                </div>
                                            </div> */}

                                            <div className="my-auto">
                                                <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
              
                                </form>

                            </div>

                        </div>

                    </div>

                    </div>
                </div>
            </div>

        </>
    )
}
export default Classroom_form;